export interface InsightsPageProps {}

export interface InsightsPageCmp
  extends React.FunctionComponent<InsightsPageProps> {
  route: string;
}

export enum SplashPageTypes {
  provisioning = 'provisioning',
  error = 'error',
  unauthorized = 'unauthorized',
}
